import EmptyList from '@anm/components/EmptyList';
import DestinationList from '@anm/components/stream/destination_management/DestinationList';
import getDestinationStorageKey from '@anm/components/stream/destination_management/helpers/getDestinationStorageKey';
import useAddDestination from '@anm/components/stream/destination_management/hooks/useAddDestination';
import useDestinationsList from '@anm/components/stream/destination_management/hooks/useDestinationList';
import browserStore from '@anm/helpers/browserStore';
import { userDestinationsActions, userDestinationsSelectors } from '@anm/store/modules/userDestinations';
import { useEffect, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import config from '../../../../config';
import Loader from '../Loader';
import { SectionWrapper } from '../Wrapper';
import { getEmptyListProps } from '../helpers';
import { useDestinationListIsError } from '../hooks/useDestinationsList';

import { useDeleteDestination } from './hooks';

const { urls } = config();

const DestinationsTab: FC = () => {
  const dispatch = useDispatch();
  const isError = useDestinationListIsError();
  const [isPending, list] = useDestinationsList();
  const [isDeletePending, handleDeleteDestination] = useDeleteDestination();

  const isEmptyList = isError || (list && !list.length);

  const [addDestinationList, renderConnectToFacebookModal, facebookGroupModal] = useAddDestination({
    waveApiUrl: urls.apiWave,
    isReconnect: true
  });

  useEffect(() => {
    if (!isError) return;

    browserStore.remove(getDestinationStorageKey());
    dispatch(userDestinationsActions.cleanDestinations());
  }, [isError]);

  const isDeleteDestinationError = useSelector(userDestinationsSelectors.selectDeleteDestinationError);

  if (isPending) return <Loader />;

  const emptyListProps = getEmptyListProps({
    isError,
    iconSrc: 'images/icons/lps/full_globe.png',
    description: 'Add your Facebook pages <br/>and YouTube channels here'
  });

  if (isEmptyList) {
    return <EmptyList isArrow={!isError} {...emptyListProps} />;
  }

  if (!list) return null;

  return (
    <SectionWrapper>
      {facebookGroupModal()}
      {renderConnectToFacebookModal()}
      <DestinationList
        {...{ list }}
        destinations={addDestinationList}
        isPending={isDeletePending}
        isDeleteError={isDeleteDestinationError}
        onDelete={handleDeleteDestination}
      />
    </SectionWrapper>
  );
};

export default DestinationsTab;
